import userApi from "api/userApi";
import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import { COLOR_USER_TYPE_BAR, getPlatFormImage, USER_TYPE_BAR_OPTION } from "helpers/constans";
import { ceil } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { components } from "react-select";
import { AsyncPaginate, wrapMenuList } from "react-select-async-paginate";
import { toast } from "react-toastify";
import { capitalizeFirstLetter } from "utils";
import NO_IMAGE from "../../assets/images/users/ic_defaul_avatar2.png";
import referralApi from "api/referralApi";

interface Option {
  label: string | any;
  value: string;
}
interface DropdownOptionProps {
  name?: string;
  listCheckedUsers?: string | null;
  debounceTimeout?: number;
  onChangeSelect?: (params: Option) => void;
  isMulti?: boolean;
  placeholder?: string;
  isShowIconCheck?: boolean;
  hideSelectedOptions?: boolean;
  isAllOption?: boolean;
  paramsTypeUsers?: string;
  isDisabled?: boolean;
  keywordSearch?: string;
  isHideBatenderNull?: boolean;
  isClearable?: boolean;
  isShowAvatar?: boolean;
  isShowOnManualPush?: boolean;
}
const LIMIT = 30;

const DropdownAsyncUsersReferral = ({
  name = "",
  listCheckedUsers,
  debounceTimeout = 700,
  onChangeSelect,
  isMulti = false,
  placeholder,
  isShowIconCheck = false,
  hideSelectedOptions = true,
  isAllOption = false,
  paramsTypeUsers = 'receiver',
  isDisabled = false,
  isHideBatenderNull,
  isClearable = true,
  isShowAvatar = false,
  isShowOnManualPush = false
}: DropdownOptionProps) => {
  const { t, i18n } = useTranslation();
  const [isAllCheckedUsers, setIsAllCheckedUsers] = useState(false);

  const OPTION_ALL_DEFAULT = { label: t("All Filter"), value: "all" };

  const [options, setOptions] = useState([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  const loadListUsers = async ({
    page,
    limit,
    search,
  }: {
    page: number;
    limit: number;
    search?: string;
  }) => {
    try {
      let params: any = {
        page,
        limit,
        keyword: search,
        ...(isShowOnManualPush === false ? { type: paramsTypeUsers } : null),
      };

      const {
        data: { items, pagination },
        code,
      } = await referralApi.rewardUsers(params);

      if (!code) {
        return { success: false };
      }

      let filterData = items;
      if (isHideBatenderNull) {
        filterData = items?.filter((item: any) => {
          if (item?.bar?.id) {
            return item;
          }
        });
      }

      const dataUsersOptions = filterData?.map((a: any) => {
        if (isShowOnManualPush) {
          let platform = a?.platform;
          let imgPlatform = getPlatFormImage(platform);

          return {
            value: String(a?.id),
            label: (
              <div className="d-flex align-items-center gap-2">
                <div
                  style={{
                    height: "30px",
                    width: "30px",
                    minWidth: "30px",
                    overflow: "hidden",
                    borderRadius: "15px",
                    objectFit: "cover",
                    backgroundColor: "#eaeaea",
                    zIndex: 99,
                  }}
                >
                  <img
                    src={a?.profile_image_url || NO_IMAGE}
                    alt={a?.nickname}
                    height={30}
                    width={30}
                    style={{
                      minWidth: "30px",
                      overflow: "hidden",
                      borderRadius: "50%",
                      objectFit: "cover",
                      backgroundColor: "#eaeaea",
                    }}
                  />
                </div>
                <div>
                  <div className="text-left d-flex align-items-center">
                    <small
                      className={`rounded-pill badge bg-${COLOR_USER_TYPE_BAR[a?.type] || "secondary"
                        }`}
                    >
                      {t(
                        USER_TYPE_BAR_OPTION?.find(
                          (item: any) => (item?.value) === (a?.type)
                        )?.label || ""
                      )}
                    </small>
                    <small className="px-1"> | </small>
                    <small className="d-flex gap-1">
                      {imgPlatform && (
                        <img
                          src={imgPlatform}
                          width={16}
                          height={16}
                          alt="platform"
                        />
                      )}
                      {t(
                        capitalizeFirstLetter(
                          platform === "default" || platform == "guest"
                            ? "Email"
                            : platform
                        )
                      )}
                    </small>
                    {
                      a?.user_device?.udid_2 && (
                        <>
                          <small className="px-1"> | </small>
                          <small>
                            {a?.user_device?.udid_2}
                          </small>
                        </>
                      )
                    }
                  </div>

                  <div>
                    {`${a?.nickname ? a?.nickname + " -" : ""} ${a?.email}`}
                  </div>
                </div>
              </div>
            ),
            data: a,
          };
        }

        return {
          value: String(a?.id),
          label: (
            <div className="d-flex align-items-center gap-2">
              {
                isShowAvatar && (
                  <div
                    style={{
                      height: "22px",
                      width: "22px",
                      minWidth: "22px",
                      overflow: "hidden",
                      borderRadius: "15px",
                      objectFit: "cover",
                      backgroundColor: "#eaeaea",
                      zIndex: 99,
                    }}
                  >
                    <img
                      src={a?.profile_image_url || NO_IMAGE}
                      alt={a?.nickname}
                      height={22}
                      width={22}
                      style={{
                        minWidth: "22px",
                        overflow: "hidden",
                        borderRadius: "50%",
                        objectFit: "cover",
                        backgroundColor: "#eaeaea",
                      }}
                    />
                  </div>
                )
              }
              <div>{`${a?.nickname ? a?.nickname + " -" : ""} ${a?.email}`}</div>
            </div>
          ),
          data: a,
        };
      });
      return {
        code,
        dataUsersOptions: dataUsersOptions || [],
        lastPage: ceil(pagination?.total / pagination?.limit),
      };
    } catch (err) {
      return {
        code: 404,
        dataUsersOptions: [],
        lastPage: 1,
      };
    }
  };

  async function loadOptions(
    search: string,
    loadedOptions: any[],
    { page }: { page: number }
  ) {
    const { code, dataUsersOptions, lastPage } = await loadListUsers({
      page,
      limit: LIMIT,
      search,
    });
    let dataUsersOptionsFormat = dataUsersOptions || [];

    if (code !== 200) {
      toast(`${t("Failed to load data")}`, CONFIG_OPTION_TOAST_ERROR);
      return {
        options: [],
        hasMore: false,
      };
    }
    let lastPageFormat = lastPage ? lastPage : 1;
    let options = dataUsersOptionsFormat;

    setOptions(options);

    return {
      options: options,
      hasMore: lastPageFormat > page,
      additional: {
        page: page + 1,
      },
    };
  }

  const MenuList = (props: any) => {
    let childComponent = props?.children;
    if (props?.children?.length > 0) {
      const allOption = props?.children?.filter(
        (item: any) => item?.props?.value === OPTION_ALL_DEFAULT?.value
      );
      let fixedIndex = -1;
      if (allOption) {
        fixedIndex = props?.children.indexOf(allOption?.[0]);
      }
      const fixedElement = props?.children?.[fixedIndex];

      const childComponentFormat = (
        (fixedIndex != -1 ? props?.children.slice(1) : props?.children) || []
      )?.sort((a: any, b: any) => {
        let pointA = a.props.isSelected === true ? 1 : 0;
        let pointB = b.props.isSelected === true ? 1 : 0;
        return pointB - pointA;
      });

      if (fixedElement) {
        childComponent = [fixedElement, ...childComponentFormat];
      } else {
        childComponent = childComponentFormat;
      }
    }

    return (
      <components.MenuList {...props}>{childComponent}</components.MenuList>
    );
  };

  const OptionFormat = (props: any) => {
    if (props?.isSelected && props?.value === OPTION_ALL_DEFAULT?.value) {
      setIsAllCheckedUsers(true);
    } else if (!props?.isSelected && props?.value === OPTION_ALL_DEFAULT?.value) {
      setIsAllCheckedUsers(false);
    }

    return (
      <components.Option {...props} style={{ zIndex: 999 }}>
        <div className="d-flex align-items-center gap-2">
          {(props?.isSelected || isAllCheckedUsers) && isShowIconCheck ? (
            <i className="ri-check-line align-middle fs-14" />
          ) : (
            ""
          )}
          {props.data?.label}
        </div>
      </components.Option>
    );
  };

  const MenuListAsync = wrapMenuList(MenuList);

  const optionsMemo = useMemo(() => {
    return [...(isAllOption ? [OPTION_ALL_DEFAULT] : []), ...options];
  }, [JSON.stringify(options), isAllOption, i18n?.language]);

  useEffect(() => {
    if (((listCheckedUsers as any)?.value === OPTION_ALL_DEFAULT?.value || !(listCheckedUsers as any)?.value) && isAllOption) {
      setOnChangeOption(OPTION_ALL_DEFAULT)
    }
  }, [i18n.language, isAllOption, JSON.stringify(listCheckedUsers)]);

  return (
    <AsyncPaginate
      key={i18n.language}
      name={name}
      isMulti={isMulti}
      isClearable={isClearable}
      // defaultOptions
      options={optionsMemo}
      debounceTimeout={debounceTimeout}
      value={listCheckedUsers}
      loadOptions={loadOptions}
      placeholder={placeholder}
      className="dropdown-status-rounded"
      hideSelectedOptions={false}
      onChange={(e: any) => setOnChangeOption(e)}
      additional={{
        page: 1,
      }}
      components={{
        Option: OptionFormat,
        ...(isMulti ? { MenuList: MenuListAsync } : null),
        // MenuList: MenuListAsync,
      }}
      closeMenuOnSelect={hideSelectedOptions}
      menuPortalTarget={document.body}
      styles={{
        option: (styles: any) => {
          let styleNew = isMulti
            ? {
              ...styles,
              backgroundColor: "white",
              zIndex: 99,
              color: "black",
            }
            : styles;

          return styleNew;
        },
        control: (styles: any, { isFocused }: any) => {
          return {
            ...styles,
            borderColor: "#e9ebec",
            borderRadius: "0.6rem",
            color: "white",
            "&:hover": { borderColor: "#009ef7" },
          };
        },
        multiValue: (styles: any) => {
          return {
            ...styles,
            backgroundColor: "#009ef7",
          };
        },
        multiValueLabel: (styles: any) => ({
          ...styles,
          color: "white !important",
        }),
        menuPortal: (base: any) => ({
          ...base,
          zIndex: 1051,
        }),
      }}
      isDisabled={isDisabled}
    />
  );
};

export default DropdownAsyncUsersReferral;
